import { isNumber, isUndefined } from "../../../omnia";
import { CroppingVm } from "./cropping";

export interface IIndexDataAttr {
    key: string;
    description: string;
    provider?: (target: any, nutrient: string) => number;
    mapView?: string;
}

export function getIndexData(def: IIndexDataAttr, target: any, nutrient: string) {

    let provider = def.provider || ((target, nutrient) => {
        let t = target ? target[def.key] : null;
        return (t ? t[nutrient] : null) || 0;
    });

    return provider(target, nutrient);

}


export function getCroppingIndexAttrs(): IIndexDataAttr[] {

    return [
        {
            key: "openingBalance", description: "Opening balance", mapView: "ob", provider: (c: CroppingVm, nutrient: string) => {

                if (c.openingBalance) {
                    let r = c.openingBalance[nutrient];
                    if (isNumber(r) && r) return r;
                }

            }
        },
        {
            key: "openingReq", description: "Initial requirements", provider: (c: CroppingVm, nutrient: string) => {

                if (c.requirements) {
                    let r = c.requirements["Required" + nutrient];
                    if (isNumber(r) && r) return r;
                }

                let r = c.getRequiredNutrient(nutrient);
                if (isUndefined(r)) return undefined;
                return r || 0;
            }
        },
        { key: "contrib", description: "Total contributions", mapView: "contrib" },
        { key: "closingReq", description: "Closing requirements", mapView: "closingReq" },
    ];

}

export function getPlanIndexAttrs(): IIndexDataAttr[] {

    return [
        { key: "openingReq", description: "Average opening requirements" },
        { key: "contrib", description: "Average contribution" },
        { key: "closingReq", description: "Average closing requirements" },
    ];

}
